"use strict";
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsConnectorMappers = exports.TeamsConnectorModels = exports.TeamsConnectorClientContext = exports.TeamsConnectorClient = void 0;
const Models = require("./models");
exports.TeamsConnectorModels = Models;
const Mappers = require("./models/mappers");
exports.TeamsConnectorMappers = Mappers;
const operations = require("./operations");
const teamsConnectorClientContext_1 = require("./teamsConnectorClientContext");
Object.defineProperty(exports, "TeamsConnectorClientContext", { enumerable: true, get: function () { return teamsConnectorClientContext_1.TeamsConnectorClientContext; } });
class TeamsConnectorClient extends teamsConnectorClientContext_1.TeamsConnectorClientContext {
    /**
     * Initializes a new instance of the TeamsConnectorClient class.
     *
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    constructor(credentials, options) {
        super(credentials, options);
        this.teams = new operations.Teams(this);
    }
}
exports.TeamsConnectorClient = TeamsConnectorClient;
__exportStar(require("./operations"), exports);
//# sourceMappingURL=teamsConnectorClient.js.map